import Vue from 'vue'
import {
  Table,
  TableColumn,
  Pagination
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
// Vue.component(Message.name, Message) // 通过加载组件的方式引入,不然会自动弹
